<template>
  <div v-inview:animate="'fadeInUp'">
    <!--Button-->
    <div class="row">
      <!--Agree-->
      <div  @click="toggleIsAgree" class="column">
        <div class="w-24px" :class="{'b-D7E1EA': !agreement.is_agreed, 'b-1BAAF1': agreement.is_agreed }" style="position: absolute;">
          <img class="checkbox" src="@/assets/images/agreements/check.svg" />
        </div>
      </div>
      <!--Title-->
      <div @click="toggleIsAgree" class="column-title">
        <b>{{agreement.title}}</b>
      </div>
      <!--Arrow-->
      <div @click="toggleIsOpen" class="column-detail">
        <img class="cen" src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down" v-if="agreement.content" />
      </div>
    </div>
    <!--Content-->
    <div ref="content" class="h-0px o-0 o-h contents" >
      <div
          v-if="agreement.content"
          v-html="agreement.content"
        >
        <!-- {{agreement.content}} -->
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, TweenLite, Circ } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin)

export default {
  name: 'AgreementItem',
  components: {},
  props: {
    agreement: {
      type: Object,
      default() { return null }
    },
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  created() {},
  mounted() {},
  destroyed() {},
  computed: {
    isAgree() {
      if (!this.agreement) return false
      return this.agreement.is_agreed
    }
  },
  methods: {
    toggleIsAgree() {
      // Toggle
      this.agreement.is_agreed = !this.agreement.is_agreed
      // Toggle All
      if (this._.get(this.agreement, 'is_all')) {
        this.$emit('toggleAll')
      }
    },
    toggleIsOpen() {
      if (!this._.get(this.agreement, 'uuid')) { return }
      if (this._.get(this.agreement, 'code') === 'SERVICE') {
        this.$router.push({ name: 'terms/service' })
        return
      }
      if (this.agreement.content) {
        this.isOpen = !this.isOpen

        if (this.isOpen) {
          TweenLite.to(this.$refs.content, 0.5, { height: 'auto', opacity: 1, ease: Circ.easeInOut })
        } else {
          TweenLite.to(this.$refs.content, 0.5, { height: 0, opacity: 0, ease: Circ.easeInOut })
        }
      } else if (this.agreement.image || this.agreement.file) {
        this.$router.push({
          name: 'agreements/detail',
          params: {
            agreement: this.agreement
          }
        })
        // this.$emit('openFile', { file: this.agreement.file, image: this.agreement.image })
      }
    }
  }
}
</script>

<style scoped>
  .checkbox {
    position: relative;
    padding-top: 6px;
  }
  .row {
    margin-top:0;
    padding-top:0;
  }
  .column-title {
    margin-left: 40px;
  }
  .column-detail {
    margin-top:5px;
    margin-left: 15px;
  }
  .contents {
    text-align: left;

  }
</style>
